export default __webpack_public_path__ + "static/media/fauna-mobile-tut-2.f5313118.png";